import { Plus } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { appRoutes } from '../../../app-routes';
import { PageHeader } from '../../../components/common/PageHeader';
import { Button } from '../../../components/ui/button';
import { STATUS_COPY, TOOL_LIST_COPY } from '../agents-copy';
import { StatusNote } from '../StatusNote';
import styles from './ToolListPage.module.css';
import { ToolRow } from './ToolRow';
import { ToolStatusFilter } from './ToolStatusFilter';
import { useToolList, type ToolListFilter } from './useToolList';

export const ToolListPage = () => {
  const [filter, setFilter] = useState<ToolListFilter>('active');
  const { data: tools, isLoading, hasNextPage, fetchNextPage, isFetchingNextPage } = useToolList(filter);
  const toolsFailedToLoad = !isLoading && tools === undefined;
  const partnerHasTools = tools !== undefined && tools.length > 0;
  const toolListIsEmpty = tools !== undefined && tools.length === 0;
  const loadMoreLabel = isFetchingNextPage ? STATUS_COPY.loading : STATUS_COPY.loadMore;
  const newToolLink = (
    <Link to={appRoutes.AGENT_TOOL_NEW} className={styles.newTool}>
      <Plus aria-hidden="true" />
      {TOOL_LIST_COPY.newTool}
    </Link>
  );

  return (
    <section className={styles.page}>
      <PageHeader
        title={TOOL_LIST_COPY.title}
        description={TOOL_LIST_COPY.description}
        right={newToolLink}
      />
      <ToolStatusFilter value={filter} onChange={setFilter} />
      {isLoading && <StatusNote>{STATUS_COPY.loading}</StatusNote>}
      {toolsFailedToLoad && <StatusNote tone="error">{TOOL_LIST_COPY.loadErrorNote}</StatusNote>}
      {toolListIsEmpty && <p className={styles.empty}>{TOOL_LIST_COPY.emptyNotes[filter]}</p>}
      {partnerHasTools && (
        <div className={styles.tableFrame}>
          <table>
            <thead>
              <tr>
                <th scope="col">{TOOL_LIST_COPY.toolColumn}</th>
                <th scope="col">{TOOL_LIST_COPY.requestColumn}</th>
                <th scope="col">{TOOL_LIST_COPY.usedInColumn}</th>
                <th scope="col">{TOOL_LIST_COPY.statusColumn}</th>
              </tr>
            </thead>
            <tbody>
              {tools.map(tool => (
                <ToolRow key={tool.id} tool={tool} />
              ))}
            </tbody>
          </table>
        </div>
      )}
      {hasNextPage && (
        <Button
          type="button"
          variant="outline"
          className={styles.loadMore}
          disabled={isFetchingNextPage}
          onClick={() => fetchNextPage()}>
          {loadMoreLabel}
        </Button>
      )}
    </section>
  );
};
